<template>
  <div class="oneui-swiper" :style="{height:direction=='vertical'?(height+'px'):'100%'}">
    <div :class="['oneui-swiper-wrapper',isTransition?'is-transition':'',direction]" id="oneuiSwiper" :style="{transform:'translate'+(direction=='horizontal'?'X':'Y')+`(${-currentIndex*100+'%'})`}"
    @mouseenter="emitHover" @mouseleave="leave"
    >
      <div :class="['oneui-swiper-item',direction]" v-for="(item,index) in formatItems" :key="index" :style="{backgroundColor:`pink`}">
        <img :src="formatProps(item,'src')" v-if="type=='image'"/>
        <span v-else>{{formatProps(item,'content')}}{{`currentIndex:${currentIndex}`}}</span>
      </div>
    </div>
  </div>
</template>

<script>
  /**
   * 自定义滑块组件
   * @description 自定义滑块组件，类似与轮播图，但更轻量
   * @property {String} type=[image|text]子组件类型，如果为image且items中为Object,需要在props中指定src的属性.如果为text且item为Object，需要在props中指定content的属性
   * @property {Array} items 滑块元素
   * @property {String} direction=[horizontal|vertical] 滑动方向
   * @property {Number} interval 滑块停留时间
   * @property {Boolean} autoPlay 是否自动滑动
   * @property {Boolean} hoverStop 鼠标经过时停止自动播放
   * @property {Number} startIndex 滑块开始的起点索引，默认为0
   * @property {String} animation=[ease|fade|qubic] 滑动动画，默认为ease
  **/
  import mixins from '../../mixins/index.js';
  export default{
    name:'swiper',
    mixins:[mixins.crmCommon],
    props:{
      type:{
        type:String,
        default:'image'
      },
      props:{
        type:Object,
        default:()=>{
          return {}
        }
      },
      height:{
        type:Number,
        default:200
      },
      items:{
        type:Array,
        default:()=>{
          return []
        }
      },
      direction:{
        type:String,
        default:'horizontal'
      },
      interval:{
        type:Number,
        default:3000
      },
      autoPlay:{
        type:Boolean,
        default:true
      },
      hoverStop:{
        type:Boolean,
        default:true
      },
      startIndex:{
        type:Number,
        default:0
      },
      animation:{
        type:String,
        default:'ease-in-out'
      }
    },
    data(){
      return{
        playTimer:null,
        currentIndex:0,
        formatItems:[],
        currentStartIndex:0,
        color:'blue',
        isTransition:true
      }
    },
    watch:{
      currentIndex(val){
        if(val==this.currentStartIndex+1){
          this.isTransition=true;
        }
      }
    },
    mounted() {
      let _self=this;
      const element=document.getElementById('oneuiSwiper');
      this.animationListener(element,'TransitionEnd',function(){
        const length=_self.items.length;

        if(_self.currentIndex==length+1){
          _self.isTransition=false;
          _self.currentIndex=_self.currentStartIndex;
        }
      })
      this.init();
    },
    destroyed() {
      this.clearTimers();
    },
    methods:{
      init(){
        this.formatItems=this.items;
        const length=this.items.length;
        this.currentIndex=this.currentStartIndex=this.startIndex;
        if(this.autoPlay && this.items.length>1){
          let items=this.clone(this.items);

          items.unshift(this.items[length-1]);

          items.push(this.items[0]);

          this.formatItems=items;

          this.currentStartIndex+=1;

          this.currentIndex+=1;

          this.setTimers();
        }
      },
      play(){
        this.currentIndex++;
      },
      setTimers(){
        this.playTimer=setInterval(()=>{
          this.play();
        },this.interval);
      },
      clearTimers(){
        clearInterval(this.playTimer);
      },
      emitClick(item){
        this.$emit('click',item);
      },
      emitHover(item){
        if(this.hoverStop){
          this.clearTimers();
        }
        this.$emit('hover',item);
      },
      leave(){
        if(!this.isEmpty(this.playTimer)){
          this.setTimers();
        }
      },
      emitChange(index){
        this.$emit('change',index);
      },
      formatProps(item={},key){
        if(this.rawType(item)!=='Object')return item;
        return item[this.props[key]]?item[this.props[key]]:item;
      }
    }
  }
</script>

<style scoped>
  .oneui-swiper{
    display: inline-block;
    width: 100%;
    height: 100%;
    overflow: hidden;
  }
  .is-transition{
    transition: transform 0.3s;
  }
  .oneui-swiper-wrapper.horizontal{
    white-space: nowrap;
  }
  .oneui-swiper-wrapper.vertical{
    height: 100%;
  }
  .oneui-swiper-item.horizontal{
    width: 100%;
    display: inline-block;
  }
  .oneui-swiper-item.vertical{
    width: 100%;
    height: 100%;
    display: block;
  }
</style>



// WEBPACK FOOTER //
// src/common/components/swiper/swiper.vue